export default "__VITE_ASSET__73aac9b1__"